import { render, staticRenderFns } from "./BankStatementActivity.vue?vue&type=template&id=0a508faf&scoped=true&"
import script from "./BankStatementActivity.vue?vue&type=script&lang=js&"
export * from "./BankStatementActivity.vue?vue&type=script&lang=js&"
import style0 from "../../../assets/style/base.css?vue&type=style&index=0&id=0a508faf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a508faf",
  null
  
)

export default component.exports